import React, { useRef, useState, useEffect } from 'react'
// import Skeleton from 'react-loading-skeleton'
import { Link, useNavigate } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { Table } from "antd";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../../Config';
// import { adminMainUrl } from '../../../Config';
const PickedRateRequest = ({ grid, headers, loading, arr, List, quotationId, fetchQuotations, count, setCount }) => {
    const scrollContainerRef = useRef(null);
    console.log(List, "List///////////////////")
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    // const [count, setCount] = useState(1);
    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
        setScrollLeft(scrollContainerRef.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };
    useEffect(() => {
        fetchQuotations()
    }, [count]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollContainerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed here
        scrollContainerRef.current.scrollLeft = scrollLeft - walk;
    };
    const totalPages = List?.pagination?.totalPages || 1;
    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCount(pageNumber);
        }
    };
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPageNumbersToShow = 5;

        if (totalPages <= maxPageNumbersToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            if (count <= 3) {
                pageNumbers.push(1, 2, 3, 4, '...', totalPages);
            } else if (count > 3 && count < totalPages - 2) {
                pageNumbers.push(1, '...', count - 1, count, count + 1, '...', totalPages);
            } else {
                pageNumbers.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return pageNumbers;
    };

    const pageNumbers = getPageNumbers();

    const navigate = useNavigate();
    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    function capitalizeText(text) {
        return text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    }
    const AcceptRequest = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/pricing/accept-job`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            toast.success(data?.msg);
            navigate('/flexichain/query-info-give-rates', { state: { quotationId: quotationId } });
        } catch (error) {
            toast.error(error);
            console.log(error);
        }
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    const columns = [
        { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "Email", dataIndex: "email", key: "email" },
        { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
        { title: "Origin", dataIndex: "origin", key: "origin" },
        { title: "Destination", dataIndex: "destination", key: "destination" },
        { title: "Shipment Mode", dataIndex: "shipmentMode", key: "shipmentMode" },
        // { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
        { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];
    const dataSource = List?.data?.map((value, i) => ({
        key: i, // Add a unique key for each row
        requestNo: value?.request_no, // Changed to camelCase
        date: formatDate(value?.createdAt), // Ensure date formatting as needed
        name: (
            <h2 className="d-flex align-items-center">
                <Link to="#" className="avatar avatar-sm me-2">
                    <img className="img-fluid" src="/assets/img/profiles/avatar-19.jpg" alt="avatar" />
                </Link>
                <Link to="#" className="d-flex flex-column">
                    <span className="text-default">{value?.full_name}</span>
                </Link>
            </h2>
        ),
        email: value?.email, // Make sure to use the correct data field for email
        phoneNumber: value?.phone, // Correct data field for phone number
        // origin: value?.origin, // Correct data field for origin
        // destination: value?.destination, // Correct data field for destination
        // shipmentType: value?.shipment_type?.name, // Correct field for shipment type
        // shipmentVia: value?.shipment_via?.name, // Correct field for shipment via
        origin: value?.origin_type == "AIRPORT" ? "Delhi, India" : `${value?.origin_address}, ${value?.origin_city ? value?.origin_city?.name : ""}, ${value?.origin_state ? value?.origin_state?.name : ""}, ${value?.origin_country ? value?.origin_country?.name : ""} `,
        destination: value?.origin_type == "AIRPORT" ? "Mumbai, India" : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} `,
        shipmentMode: value?.shipment_mode,
        pickedBy: value?.picked_by ? value?.picked_by : "-",
        // pickedBy: value?.picked_by ? value?.picked_by : "Empty", // Correct field for picked by
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    {/* <div className="dropdown-item" to="#" onClick={() => {
                        // setViewData(value);
                        // setId(value?.id)
                    }} data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit_form">
                        <i className="ti ti-edit text-blue"></i> Give Rate
                    </div>
                    <div className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                        <i className="ti ti-trash text-danger"></i> Delete
                    </div> */}
                    <div className="dropdown-item" onClick={() => { navigate('/flexichain/query-info-give-rates', { state: { quotationId: value.id } }) }}>
                        <i className="ti ti-eye text-blue-light"></i> Preview
                    </div>
                </div>
            </div>
        ),
    }));
    return (
        <>
            {
                grid ? <div className="table-responsive custom-table">
                    <Table className="table datanew dataTable no-footer"
                        rowSelection={rowSelection} dataSource={dataSource} columns={columns} pagination={false} />
                </div> :
                    <div className='row'>
                        {
                            List?.data?.length > 0 ?
                                List?.data?.map((value, i) => {
                                    return (
                                        <div key={i} className="col-xxl-3 col-xl-4 col-md-6">
                                            <div className="card border">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                        <div className="d-flex align-items-center">
                                                            <a
                                                                href="#"
                                                                className="avatar avatar-md flex-shrink-0 me-2"
                                                            >
                                                                <img
                                                                    src="/assets/img/profiles/avatar-19.jpg"
                                                                    alt="img"
                                                                />
                                                            </a>
                                                            <div>
                                                                <h6>
                                                                    <a
                                                                        href="#"
                                                                        className="fw-medium"
                                                                    >
                                                                        {value?.full_name}
                                                                    </a>
                                                                </h6>
                                                                <p className="text-default">{value?.quotation_user_type}</p>
                                                            </div>
                                                        </div>
                                                        <div className="dropdown table-action">
                                                            <a
                                                                href="#"
                                                                className="action-icon "
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="fa fa-ellipsis-v" />
                                                            </a>
                                                            <div className="dropdown-menu dropdown-menu-right">
                                                                {/* <div className="dropdown-item" to="#" onClick={() => {
                        // setViewData(value);
                        // setId(value?.id)
                    }} data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit_form">
                        <i className="ti ti-edit text-blue"></i> Give Rate
                    </div>
                    <div className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                        <i className="ti ti-trash text-danger"></i> Delete
                    </div> */}
                                                                <div className="dropdown-item" onClick={() => { navigate('/flexichain/query-info-give-rates', { state: { quotationId: value.id } }) }}>
                                                                    <i className="ti ti-eye text-blue-light"></i> Preview
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-block">
                                                        <div className="d-flex flex-column mb-3">
                                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                                                <i className="ti ti-mail text-dark me-1" />
                                                                {value?.email}
                                                            </p>
                                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                                                <i className="ti ti-phone text-dark me-1" />
                                                                {value?.phone}
                                                            </p>
                                                            <p className="text-default d-inline-flex align-items-center">
                                                                <i className="ti ti-map-pin-pin text-dark me-1" />
                                                                {value?.origin_type == "AIRPORT" ? "Mumbai, India" : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} `}
                                                            </p>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <span className="badge badge-tag badge-success-light me-2">
                                                                {value?.quote_status?.name}
                                                            </span>
                                                            {/* <span className="badge badge-tag badge-warning-light">
                                                                   Rated
                                                               </span> */}
                                                        </div>
                                                    </div>
                                                    {/* <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                                                           <div className="d-flex align-items-center grid-social-links">
                                                               <a
                                                                   href="#"
                                                                   className="avatar avatar-xs text-dark rounded-circle me-1"
                                                               >
                                                                   <i className="ti ti-mail fs-14" />
                                                               </a>
                                                               <a
                                                                   href="#"
                                                                   className="avatar avatar-xs text-dark rounded-circle me-1"
                                                               >
                                                                   <i className="ti ti-phone-check fs-14" />
                                                               </a>
                                                               <a
                                                                   href="#"
                                                                   className="avatar avatar-xs text-dark rounded-circle me-1"
                                                               >
                                                                   <i className="ti ti-message-circle-share fs-14" />
                                                               </a>
                                                               <a
                                                                   href="#"
                                                                   className="avatar avatar-xs text-dark rounded-circle me-1"
                                                               >
                                                                   <i className="ti ti-brand-skype fs-14" />
                                                               </a>
                                                               <a
                                                                   href="#"
                                                                   className="avatar avatar-xs text-dark rounded-circle"
                                                               >
                                                                   <i className="ti ti-brand-facebook fs-14" />
                                                               </a>
                                                           </div>
                                                           <div className="d-flex align-items-center">
                                                               <div className="set-star text-default me-2">
                                                                   <i className="fa fa-star filled me-1" />
                                                                   4.2
                                                               </div>
                                                               <a
                                                                   href="javascript:void(0);"
                                                                   className="avatar avatar-md"
                                                                   data-bs-toggle="tooltip"
                                                                   data-bs-original-title="Mervin"
                                                                   data-bs-placement="top"
                                                               >
                                                                   <img
                                                                       src="/assets/img/profiles/avatar-14.jpg"
                                                                       alt="img"
                                                                   />
                                                               </a>
                                                           </div>
                                                       </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) :
                                <div className="box-grid">
                                    No data available
                                </div>
                        }
                    </div>
            }
            <div className="pagination-controls my-5 d-flex justify-content-center align-items-center gap-2">
                <button
                    className=''
                    onClick={() => handlePageChange(count - 1)}
                    disabled={count === 1}
                >
                    <img src="/img/right.png" className='' alt="right" />
                </button>

                {pageNumbers.map((number, index) =>
                    number === '...' ? (
                        <span key={index} className="">...</span>
                    ) : (
                        <span
                            key={number}
                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                            onClick={() => handlePageChange(number)}
                            style={{ cursor: 'pointer' }}
                        >
                            {number}
                        </span>
                    )
                )}

                <button
                    onClick={() => handlePageChange(count + 1)}
                    disabled={count === totalPages}
                >
                    <img src="/img/left.png" className='' alt="right" />
                </button>
            </div>
        </>
    )
}

export default PickedRateRequest